import { Injectable, signal, WritableSignal } from '@angular/core';
import { SupabaseDatabaseService } from './supabase-database.service';
import TYPES from '../constants/types';

@Injectable({
  providedIn: 'root'
})
export class PsychologistService<Psychologist> extends SupabaseDatabaseService<Psychologist> {

  psychologist: WritableSignal<Psychologist | null> = signal(null);

  async getAllActivePsychologists(): Promise<Psychologist[]>{
    const { data, error } = await this.supabase
    .from(TYPES.DATABASE.TABLES.PSYCHOLOGISTS)
    .select(`
      *
    `)
    .eq('status', TYPES.DATABASE.STATUS.ACTIVE['code']);

    if (error) {
      console.error(`Erro ao buscar PSYCHOLOGISTS em '${TYPES.DATABASE.TABLES.PSYCHOLOGISTS}':`,
        error);
      throw new Error(error.message);
    }
    
    return (data as Psychologist[]) || [];

  }

  async getAllActivePremiumPsychologists(): Promise<Psychologist[]>{
    const { data, error } = await this.supabase
    .from(TYPES.DATABASE.TABLES.PSYCHOLOGISTS)
    .select(`
      *
    `)
    .eq('status', TYPES.DATABASE.STATUS.ACTIVE['code'])
    .eq('subscription_plan', TYPES.DATABASE.PLANS.PROFESSIONAL.code);

    if (error) {
      console.error(`Erro ao buscar PSYCHOLOGISTS em '${TYPES.DATABASE.TABLES.PSYCHOLOGISTS}':`,
        error);
      throw new Error(error.message);
    }
    
    return (data as Psychologist[]) || [];

  }

  async getAllPendingPsychologists(): Promise<Psychologist[]>{
    const { data, error } = await this.supabase
    .from(TYPES.DATABASE.TABLES.PSYCHOLOGISTS)
    .select(`
      *
    `)
    .eq('status', TYPES.DATABASE.STATUS.WAITING_VALIDATION['code']);

    if (error) {
      console.error(`Erro ao buscar PSYCHOLOGISTS pendentes em '${TYPES.DATABASE.TABLES.PSYCHOLOGISTS}':`,
        error);
      throw new Error(error.message);
    }
    
    return (data as Psychologist[]) || [];

  }

  async getPsychologistByUserId(userId: string): Promise<Psychologist | null>{
    
    const { data, error } = await this.supabase
      .from(TYPES.DATABASE.TABLES.PSYCHOLOGISTS)
      .select(`
        *,
        subscriptions(*)
      `)
      .eq('user_id', userId)
      .maybeSingle();

    if (error) {
      // O código 'PGRST116' indica que nenhuma linha foi encontrada, o que não é um erro de fato.
      if (error.code === 'PGRST116') {
        return null;
      }
      console.error(`Erro ao buscar por ID em '${TYPES.DATABASE.TABLES.PSYCHOLOGISTS}':`, error);
      throw new Error(error.message);
    }

    this.psychologist.set(data);

    return data as Psychologist;
    
  }
}
